import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class RedirectLogService extends RestfulService<Models.RedirectLog> {

  constructor(private restService: RestService) {
    super(Models.RedirectLog);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('redirect-logs');
  }

}
